<!--
 * @Function: 选择题目组卷
-->

<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    centered
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <div class="selct-topic-modal" >
      <div class="selct-topic-left">
        <a-input-search @search="onSearch" style="width:100%;margin-top: 10px" placeholder="请输入分类名称"/>
        <a-tree
          :tree-data="gData"
          @select="onSelect"
        >
          <template slot="title" slot-scope="{ title }">
            <div class="title-con" >
              <div class="title-name">
                {{ title }}
              </div>
              <!-- <div class="title-operat">
                <a-icon type="form" class="op-icon"/>
                <a-icon type="delete" class="op-icon"/>
              </div> -->
            </div>
          </template>
        </a-tree>
      </div>
      <div class="selct-topic-right">
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="12" style="margin:0px 0px 16px 0px;">
              <a-col class="a-large-form" >
                <a-form-item
                  style="margin-bottom:0px;"
                  label=""
                  :required="false"
                >
                  <j-dict-select-tag v-model="queryParam.subject" placeholder="全部科目" dictCode="subject" />
                </a-form-item>
              </a-col>
              <a-col class="a-large-form" >
                <a-form-item
                  style="margin-bottom:0px;"
                  label=""
                  :required="false"
                >
                  <j-dict-select-tag v-model="queryParam.type" placeholder="全部题型" dictCode="exercise_type" />
                </a-form-item>
              </a-col>
              <a-col class="a-large-form" >
                <a-form-item label="" style="margin-bottom:0px;width:100%">
                  <j-input placeholder="搜索题目名称" v-model="queryParam.stem"></j-input>
                </a-form-item>
              </a-col>
              <a-button type="primary" @click="searchQuery" style="margin-left:5px;vertical-align: middle;">筛选</a-button>
              <a-button type="primary" @click="searchReset()" style="margin-left:5px;vertical-align: middle;">重置</a-button>
            </a-row>
          </a-form>
        </div>
        <div class="table-con">
          <a-table
            ref="table"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            size="middle"
            rowKey="id"
            :scroll="{y:420}"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            @change="handleTableChange">
            <!-- <span slot="action" slot-scope="text, record" style="width:200px">
              <a @click="up()">上移</a>
              <a-divider type="vertical" />
              <a @click="down()">下移</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确定删除吗?" @confirm="() => delTopic(record.id)">
                <a>删除</a>
              </a-popconfirm>
            </span> -->
            <span slot="stemInfo" slot-scope="text, record">
              <div v-if="text.length > 50">
                <a-tooltip>
                  <template slot="title">
                    <p v-html="text"></p>
                  </template>
                  <p v-html="text.substring(0,50)+'...'"></p>
                </a-tooltip>
              </div>
              <div v-else>
                <p v-html="text"></p>
              </div>
            </span>
          </a-table>
        </div>
        <!-- <div class="pager">
          <a-pagination size="small" :total="50" show-size-changer show-quick-jumper />
        </div> -->
      </div>
    </div>
  </a-modal>
</template>

// <script>
//   const x = 3
//   const y = 2
//   const z = 1
//   const gData = []

//   const generateData = (_level, _preKey, _tns) => {
//     const preKey = _preKey || '0'
//     const tns = _tns || gData

//     const children = []
//     for (let i = 0; i < x; i++) {
//       const key = `${preKey}-${i}`
//       tns.push({ title: key, key, scopedSlots: { title: 'title' } })
//       if (i < y) {
//         children.push(key)
//       }
//     }
//     if (_level < 0) {
//       return tns
//     }
//     const level = _level - 1
//     children.forEach((key, index) => {
//       tns[index].children = []
//       return generateData(level, key, tns[index].children)
//     })
//   }
//   generateData(z)

//   const dataList = []
//   const generateList = data => {
//     for (let i = 0; i < data.length; i++) {
//       const node = data[i]
//       const key = node.key
//       dataList.push({ key, title: key })
//       if (node.children) {
//         generateList(node.children)
//       }
//     }
//   }
//   generateList(gData)
//   const getParentKey = (key, tree) => {
//     let parentKey
//     for (let i = 0; i < tree.length; i++) {
//       const node = tree[i]
//       if (node.children) {
//         if (node.children.some(item => item.key === key)) {
//           parentKey = node.key
//         } else if (getParentKey(key, node.children)) {
//           parentKey = getParentKey(key, node.children)
//         }
//       }
//     }
//     return parentKey
//   }
import {queryExerciseTreeList} from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: 'SelectTopicModal',
     mixins: [JeecgListMixin],
    components: {
    },
    data () {
      return {
        title: '添加题目',
        width: 1000,
        visible: false,
        disableSubmit: false,
        searchValue: '',
        selectedRowKeys: [],
        // ipagination: false,
        queryParam: {
          type: undefined,
          stem: '',
          subject:undefined
        },
        dataSource: [
          // {
          //   tigan: '我是题干题干题干题干题干题干题干题干题干题干题干题干题干'
          // }
        ],
        columns: [
          {
            title: '序号',
            align: 'center',
            dataIndex: 'importNo',
            width: 50
          },
          {
            title: '题型',
            align: 'center',
            dataIndex: 'type_dictText',
            width: 80
          },
          {
            title: '题干',
            align: 'left',
            dataIndex: 'stem',
            width: 220,
            scopedSlots: { customRender: 'stemInfo' }
            // customRender: (text, row, index) => {
            //   if(text.length>50){
            //     return text.substring(0,50)+"...";
            //   }
            //   return text;
            // }
          },
          {
            title: '分值',
            align: 'center',
            dataIndex: 'score',
            width: 30
          }
        ],
        gData: [
        //   {
        //     id: 1,
        //     key: 1,
        //     isEdit: false, // 是否处于编辑状态
        //     isNewItem: false, // 该节点是否是新增节点
        //     title: '节点名字1',
        //     depth: 1, // 该节点的层级
        //     scopedSlots: { title: 'title' }, // 自定义组件需要绑定
        //     children: [
        //       {
        //         id: 2,
        //         key: 2,
        //         isEdit: false, // 是否处于编辑状态
        //         isNewItem: false, // 该节点是否是新增节点
        //         title: '子节点名字',
        //         depth: 2, // 该节点的层级
        //         scopedSlots: { title: 'title' }
        //       },
        //       {
        //         id: 21,
        //         key: 21,
        //         isEdit: false, // 是否处于编辑状态
        //         isNewItem: false, // 该节点是否是新增节点
        //         title: '子节点名字',
        //         depth: 2, // 该节点的层级
        //         scopedSlots: { title: 'title' }
        //       }
        //     ]
        //   }
        ],
         // 请求参数
        url: {
          list: "/exercise/elinkxExerciseInfo/list",
          // delete: "/exercise/elinkxExerciseInfo/delete",
          // deleteBatch: "/exercise/elinkxExerciseInfo/deleteBatch",
          // exportXlsUrl: "/exercise/elinkxExerciseInfo/exportXls",
          // importExcelUrl: "exercise/elinkxExerciseInfo/importExcel",
        },
        selectExercise:[]
      }
    },
    methods: {
      onSelectChange(selectedRowKeys,selectRows) {
        console.log('selectedRowKeys changed: ', selectRows)
        this.selectExercise = selectRows;
        this.selectedRowKeys = selectedRowKeys
      },
      loadTree(){
        queryExerciseTreeList().then((res) => {
           if (res.success) {
             this.gData=res.result;
           }else {
            this.$message.warning(res.message)
          }
        // console.log(res);
        }).finally(() => {
        })
      },
      onSearch(value) {
         let that = this;
        if(value){
          queryExerciseTreeList({'name':value}).then((res) => {
            if (res.success) {
              that.gData=res.result;
              // that.autoExpandParent=true;
            }else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
          })
        }else{
          that.loadTree();
        }
      },
      onSelect(keys, event) {
        // 获取某个分类
        this.queryParam.catalogId = keys[0];
        this.loadData(1);
        // console.log('Trigger Select', keys, event)
      },
      open (selectExercise) {
        this.visible = true;
        this.selectedRowKeys = selectExercise;
          this.loadTree();
        // this.$nextTick(() => {
        //   this.$refs.realForm.add()
        // })
      },
      // edit (record) {
      //   this.visible = true
      //   // this.$nextTick(() => {
      //   //   this.$refs.realForm.edit(record)
      //   // })
      // },
      close () {
        this.$emit('close')
        this.visible = false
      },
      handleOk () {
        if (this.selectedRowKeys.length === 0) {
         this.$message.warning('至少选择一条数据')
        } else {
          this.$emit('ok',this.selectExercise)
          this.close();
        }
        // this.$refs.realForm.submitForm()
      },
      // submitCallback() {
      //   this.$emit('ok')
      //   this.visible = false
      // },
      handleCancel () {
        this.close()
      }
    },
    // created () {
    //   this.loadTree();
    //   // this.subjectDictItems = getDictItems("subject",{});
    // }
  }
</script>
<style lang="less" scoped >
  @import '~ant-design-vue/es/style/themes/default.less';
  .selct-topic-modal{
    display: flex;
    .selct-topic-left{
      border-right: 1px solid #ddd;
      padding-right: 20px;
    }
    .selct-topic-right{
      flex: 1;
    }
    .pager{
      text-align: center;
    }
    .table-con{
      height: 400px;
    }
  }
</style>
